export const NEGOTIATORS = [
  { field: "Erika", report: true },
  { field: "Irvin", report: true },
  { field: "Jason", report: true },
  { field: "Mary", report: true },
  { field: "Rommel", report: true },
  { field: "Ross" },
  { field: "Trisha", report: true },
].map((n) => ({ ...n, label: n.field }));

export const GROUPS_PER_URL = 5;

export const URLS_RESOURCE_NAME = "urls";

export const URL_GROUPS_RESOURCE_NAME = "url_groups";
